import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const VITALS_QUERY_KEY = "VITALS_QUERY_KEY";
export const VITALS_CATALOG_QUERY_KEY = "VITALS_CATALOG_QUERY_KEY";

// #region VITALS CATALOG
export const useVitalsCatalogQuery = () => {
  return useQuery({
    queryKey: [VITALS_CATALOG_QUERY_KEY],
    retry: false,
    queryFn: getVitalsCatalog,
    staleTime: Infinity,
    placeholderData: [],
  });
};

const getVitalsCatalog = async () => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "appointmentsapi",
    path: "/vitals-catalog/list",
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
// #endregion

// #region PATIENT VITALS
export const useVitalsByPatientAndEncounterQuery = (
  patientUserId,
  encounterId
) => {
  return useQuery({
    queryKey: [VITALS_QUERY_KEY, patientUserId, encounterId],
    retry: false,
    queryFn: listPatientAndEncounterVitals.bind(this, {
      patientUserId,
      encounterId,
    }),
    placeholderData: [],
    enabled: !!patientUserId && !!encounterId,
  });
};

export const useVitalsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [VITALS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listPatientVitals.bind(this, patientUserId),
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useVitalQuery = (id, patientUserId) => {
  return useQuery({
    queryKey: [VITALS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listPatientVitals.bind(this, patientUserId),
    placeholderData: [],
    enabled: !!patientUserId,
    select: (vitals) => {
      const vital = vitals.filter((i) => i.id === id)[0];
      return vital ? vital : null;
    },
  });
};

const listPatientVitals = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "appointmentsapi",
    path: "/vitals/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};

const listPatientAndEncounterVitals = async ({
  patientUserId,
  encounterId,
}) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "appointmentsapi",
    path: "/vitals/" + patientUserId + "/" + encounterId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
// #endregion
